export default __webpack_public_path__ + "static/media/move@1x.505e505e.svg";